var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.maxHeight = {
	init: function (selector) {
		if (!selector || $(selector).length == 0) return;
		site.maxHeight.setHeight(selector);
		$(window).resize(function () {
			site.maxHeight.setHeight(selector);
		});
	},
	setHeight: function (selector) {
		$(selector).each(function () {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});
	}
};

site.entryContent = {
	init: function() {
		$("ul > li a[href$='.pdf']", '.entryContent, .box_tiny').each(function() {
			$(this).closest('li').addClass('pdf');
		});

		$("ul > li a[href^='http']", '.entryContent, .box_tiny').each(function() {
			$(this).closest('li').addClass('http');
		});
	}
};

site.placeholder = {
	init: function () {
		$('#newsFilter .years .lmnt #years').attr('aria-label', 'Velja ár');
		$('#newsFilter .months .lmnt #months').attr('aria-label', 'Velja mánuð');
	}
};

site.carouselImg = {
	init: function () {
		var $count = $("#banner_wrapper").find('li');
		if ($count.length < 2){
			$count.each(function () {
				$(this).closest('li').addClass('singleImg');
			})
		}

	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.info = {
	init:function () {
		$ExtrasOwlSettings = {
			items: 4,
			nav: true,
			margin: 30,
			navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
			autoHeight: false,
			dots: false,
			lazyLoad: true,
			lazyLoadEager: 2
		};

		site.owl.init('.info .items', $ExtrasOwlSettings);
	}
};


site.frontpage = {
	init: function() {

	}
};



site.meetings = {
	loadMore: function() {
		const seeMore = document.querySelector('#loaderMeetings #seeMore');
		if (!seeMore) {
			return;
		}
		seeMore.addEventListener('click', (e) => {
			e.preventDefault();
			document.body.classList.remove('meetingsShowLess');
			seeMore.classList.add('fadeOut');
			setTimeout(() => {
				seeMore.parentElement.remove();
			}, 400);
		})
	}
};


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.mMenu.init();
	site.accessibility.init();
	site.megamenu.init();
	site.entryContent.init();
	site.labelFocus.init();
	site.placeholder.init();
	site.carouselImg.init();
	site.meetings.loadMore();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	$frontOwlSettings = {
		items: 1,
		autoHeight: false,
		dots: true,
		lazyLoad: true,
		lazyLoadEager: 2
	};

	$frontNewsOwlSettings = {
		items: 1,
		nav: true,
		navText: ["",""],
		autoHeight: false,
		dots: false
	};

	if ($body.is('.frontpage')) {
		site.owl.init('.group .box_calendar_eventlist .eventList', $frontOwlSettings);
	}

	if ($body.is('.frontpage') && $('.img_carousel').length > 1) {
		site.owl.init('#banner_wrapper ul', $frontOwlSettings);
	}

	if ($body.is('.frontpage') && $(window).width() < 768) {
		site.owl.init('.box_newsheadlines .news__entries', $frontNewsOwlSettings);
	}

	if ($body.is('.extrasOwl')) {
		site.info.init();
	}

	$(window).resize(function () {
		if ($(window).width() < 768) {
			site.owl.init('.box_newsheadlines .news__entries', $frontNewsOwlSettings);
		} else {
			$('.box_newsheadlines .news__entries').trigger('destroy.owl.carousel');
		}
	});

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
